<template>
    <div class="templateListBox">
        <div style="display: flex">
            <el-form ref="listArgument" :model="listArgument">
                <el-form-item prop="name">
                    <el-input v-model="listArgument.doc_title" placeholder="请输入合同模板名称"></el-input>
                </el-form-item>
                <el-form-item prop="status">
                    <el-select
                        v-model="listArgument.status"
                        class="filter-item common-r"
                        placeholder="请选择模板状态"
                    >
                        <el-option
                            v-for="item in statusList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div class="searchBox">
                <el-button type="primary" @click="searchBtn">搜索</el-button>
                <el-button @click="clearBtn">清空</el-button>
            </div>
        </div>
        <avue-crud :data="data"  ref="crud" :option="option"
                   @size-change="sizeChange" :page.sync="page" @current-change="currentChange">

            <template slot-scope="scope" slot="menuLeft">
                <el-button class="custom" type="primary" @click="addBtn">新增模板</el-button>
                <el-button class="custom" type="primary" @click="viewBtn">点击查看制作说明</el-button>
            </template>
            <template slot="menuBtn" slot-scope="scope">
                <el-dropdown-item class="pull-down" @click.native="deployBtn(scope.row)">查看签署方配置</el-dropdown-item>
                <el-dropdown-item class="pull-down" @click.native="editBtn(scope.row)">编辑合同模板</el-dropdown-item>
                <el-dropdown-item class="pull-down" @click.native="enabledBtn(scope.row)" v-if="scope.row.status == 2">启用</el-dropdown-item>
                <el-dropdown-item class="pull-down" @click.native="forbiddenBtn(scope.row)" v-if="scope.row.status == 1">禁用</el-dropdown-item>
                <el-dropdown-item class="pull-down" @click.native="authorizeBtn(scope.row)" v-if="user_type.user_type==2">授权给企业员工</el-dropdown-item>
                <el-dropdown-item class="pull-down" @click.native="authorizedBtn(scope.row)" v-if="user_type.user_type==2">查看已授权员工列表</el-dropdown-item>
                <el-dropdown-item class="pull-down" @click.native="deleteBtn(scope.row)">删除合同模板</el-dropdown-item>
            </template>
        </avue-crud>
        <el-dialog
            title="编辑合同模板"
            :visible.sync="dialogVisible"
            width="30%"
            :close-on-click-modal="false">
            <el-form ref="form" :model="editContract">
                <el-form-item label="合同模板名称">
                    <el-input v-model="editContract.doc_title"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="editContractBtn">确 定</el-button>
            </span>
        </el-dialog>

    </div>
</template>

<script>
import {
    deleteContractTemplate,
    editContractTemplate,
    enableDisableTemplate,
    getTemplateList,
    viewExplanation
} from '@/api/template_kh';

    export default {
        name: 'templateList',
        data(){
            return{
                dialogVisible:false,
                editContract:{
                  id:'',
                  doc_title:'',
                },
                user_type:'',
                listArgument:{
                    doc_title:'', //合同模板名称
                    status:'',  //模板状态
                    limit:10,
                    page:1
                },
                statusList:[
                    {
                        value: '1',
                        label: '启用'
                    },
                    {
                        value: '2',
                        label: '禁用'
                    },
                ],
                page:{
                    currentPage: 1,
                    total: 20,  //总数
                    pageSize: 10
                },
                data: [],
                option: {
                    stripe: true,
                    // index:true,
                    searchMenuSpan: 3,
                    indexLabel: '序号',  //添加序号
                    selection: false, //批量选择
                    addBtn: false,  //新增按钮
                    align: 'center',  //文本居中
                    menuAlign: 'center', //操作栏居中
                    columnBtn: false,  //列动态显隐按钮
                    refreshBtn: false,  //刷新按钮
                    editBtn: false,  //编辑按钮
                    delBtn: false,  //删除按钮
                    menuWidth: 150,  //操作栏宽度设置
                    menuType: 'menu',
                    menuBtnTitle: '操作',
                    column: [
                        {
                            label: '合同模板ID',
                            prop: 'id',
                            width: '100'
                        },
                        {
                            label: '模板编号',
                            prop: 'tpl_sn'
                        },
                        {
                            label: '合同模板名称',
                            prop: 'doc_title'
                        },
                        {
                            label: '模板类型',
                            prop: 'tpl_type_txt'
                        },
                        {
                            label: '模板状态',
                            prop: 'status_txt'
                        },
                        {
                            label: '更新时间',
                            prop: 'update_time'
                        },
                    ]
                }
            }
        },
        methods:{
            // 分页
            currentChange(num){
                this.listArgument.page = num;
                getTemplateList().then(res=>{
                    this.data = res.data.list;
                    this.page.total = res.data.count;
                })
                sessionStorage.setItem('templateList',num);
            },
            // 切换每一页条数
            sizeChange(val){
                this.listArgument.page = 1;
                this.listArgument.limit = val;
                sessionStorage.removeItem('templateList')
                this.getList()
            },
            // 搜索
            searchBtn(){
                sessionStorage.removeItem('templateList')
                this.listArgument.page = 1;
                this.getList();
            },
            // 清空
            clearBtn(){
                this.listArgument.page = 1;
                this.listArgument.limit = 10;
                sessionStorage.removeItem('templateList')
                this.getList()
                this.$refs.listArgument.resetFields();
            },
            // 获取列表
            getList(){
                let num = Number(sessionStorage.getItem('templateList'));

                getTemplateList(this.listArgument).then(res=>{
                    if (res.code == 200) {
                        this.data = res.data.list;
                        this.page.total = res.data.count;
                        this.page.currentPage = (this.page.currentPage && num !== 0) ? num : 1;
                    }else {
                        this.$message.error(res.msg);
                    }
                })
            },
            // 新增模板
            addBtn(){
                this.$router.push({
                    path:'/addTemplatePage'
                })
            },
            // 查看制作说明
            viewBtn(){
                viewExplanation().then(res=>{
                    if (res.code==200){
                        window.open(res.data.goto_url,'_blank')
                    }else {
                        this.$message.error(res.msg);
                    }
                })
            },
            // 查看签署方配置
            deployBtn(row){
                this.$router.push({ path:'/signDeploy',query:{tpl_id:row.id} })
            },
            // 编辑合同模板
            editBtn(row){
                this.editContract.id=row.id;
                this.editContract.doc_title=row.doc_title;
                this.dialogVisible=true;
            },
            // 编辑合同模板确认
            editContractBtn(){
                editContractTemplate(this.editContract).then(res=>{
                    if (res.code==200){
                        window.open(res.data.docTemplateEditUrl,'_blank')
                        this.$message.success(res.msg);
                        this.dialogVisible=false;
                        this.getList()
                    }else {
                        this.$message.error(res.msg);
                    }
                })
            },
            // 启用
            enabledBtn(row){
                this.$confirm('请确认是否启用该合同模板 ', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    enableDisableTemplate({id:row.id,status:1}).then(res=>{
                        if (res.code==200){
                            this.$message.success(res.msg);
                            this.getList();
                        }else{
                            this.$message.error(res.msg);
                        }
                    })
                }).catch(() => {

                });
            },
            // 禁用
            forbiddenBtn(row){
                this.$confirm('请确认是否禁用该合同模板 ', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    enableDisableTemplate({id:row.id,status:2}).then(res=>{
                        if (res.code==200){
                            this.$message.success(res.msg);
                            this.getList();
                        }else{
                            this.$message.error(res.msg);
                        }
                    })
                }).catch(() => {

                });
            },
            // 授权给企业员工
            authorizeBtn(row){
                this.$router.push({
                    path:'/staffList',
                    query:{tpl_id:row.id}
                })
            },
            // 查看已授权员工列表
            authorizedBtn(row){
                this.$router.push({
                    path:'/authorizedList',
                    query:{tpl_id:row.id}
                })
            },
            // 删除合同模板
            deleteBtn(row){
                this.$confirm('请确认是否要删除该合同模板 ', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    deleteContractTemplate({id:row.id}).then(res=>{
                        if (res.code==200){
                            this.$message.success(res.msg);
                            this.getList();
                        }else{
                            this.$message.error(res.msg);
                        }
                    })
                }).catch(() => {

                });
            }
        },
        created() {
            this.user_type=JSON.parse(sessionStorage.getItem('shenfen'))
            let num = Number(sessionStorage.getItem('templateList'));
            if (num==0){
                this.getList();
            }else {
                this.listArgument.page = num;
                getTemplateList(this.listArgument).then(res=>{
                    this.data = res.data.list;
                    this.page.total = res.data.count;
                    this.page.currentPage = num;
                })
            }
        }
    }
</script>

<style scoped lang="scss">
    .templateListBox {
        background-color: #ffffff;
        padding: 20px;
        border-radius: 5px;
    }
    .el-form{
        display: flex;
    }
    .el-form-item{
        display: flex;
        margin-right: 10px;
    }
    .pull-down{
        padding: 10px 30px;
    }
</style>